import type { IconName } from "../assets/icons";
import { makeUrl, routes, useCurrentUrl } from "../lib/urls";
import { TabHeaderBar, Tabs } from "./TabHeader";
import { TabLink } from "./TabLink";

export type BranchesTab = "branches" | "autofix" | "autotune";

type Props = {
  branchesCount: number;
  autofixCount: number;
  autoImproveCount: number;
};

const TAB_DEFS: {
  id: BranchesTab;
  label: string;
  icon: IconName;
}[] = [
  { id: "branches", label: "Branches", icon: "git-branch" },
  { id: "autofix", label: "Autofix", icon: "radar" },
  { id: "autotune", label: "Autotune", icon: "audio-waveform" },
];

export function BranchesTabHeader({
  branchesCount,
  autofixCount,
  autoImproveCount,
}: Props) {
  const params = useCurrentUrl(routes.branches);
  const active: BranchesTab =
    params.tab === "autofix" || params.tab === "autotune"
      ? params.tab
      : "branches";
  const counts: Record<BranchesTab, number> = {
    branches: branchesCount,
    autofix: autofixCount,
    autotune: autoImproveCount,
  };
  return (
    <TabHeaderBar>
      <Tabs>
        {TAB_DEFS.map((t) => (
          <TabLink
            key={t.id}
            to={makeUrl(routes.branches, { ...params, tab: t.id })}
            replace
            active={active === t.id}
            icon={t.icon}
            label={t.label}
            count={counts[t.id] > 0 ? counts[t.id] : null}
          />
        ))}
      </Tabs>
    </TabHeaderBar>
  );
}
